<template>
  <div>
    <!-- 搜索网元 -->
    <!-- <div class="e-input-group m-b-8">
      <input
        class="e-input"
        type="text"
        :placeholder="neSearch"
        v-model="value"
        @keydown.native.enter="keydown"
      />
      <span class="hero-icon hero-icon-search" @click="keydown"></span>
    </div>-->
    <div class="h-scroll h100-80">
      <div id="tab_wizard">
        <ejs-tab id="tab_default" heightAdjustMode="None">
          <e-tabitems>
            <e-tabitem :header="headerText0" :content="content0"></e-tabitem>
            <e-tabitem :header="headerText1" :content="content1"></e-tabitem>
          </e-tabitems>
        </ejs-tab>
      </div>
      <div id="booking" style="display:none;">
        <RealtimeTaskTree ref="realtimeTaskTree" @transferMeasureObj="transferMeasureObj"></RealtimeTaskTree>
      </div>
      <div id="selectTrain" style="display:none;">
        <RealTimeNeTree ref="realtimeNeTree" @transferNe="transferNe"></RealTimeNeTree>
      </div>
    </div>
  </div>
</template>

<script>
import RealtimeTaskTree from './RealtimeTaskTree';
import RealTimeNeTree from './RealTimeNeTree';

export default {
  name: 'RealTaskManagement',
  components: {
    RealtimeTaskTree,
    RealTimeNeTree
  },
  data() {
    return {
      neSearch: this.$t('Pm.searchNe'),
      value: '',
      headerText0: {
        text: this.$t('Pm.measureTask')
      },
      headerText1: {
        text: this.$t('Pm.resource')
      },
      content0: '#booking',
      content1: '#selectTrain'
    };
  },
  methods: {
    keydown() { },
    transferMeasureObj(msg) {
      this.$emit('transferMeasureObj', msg);
    },
    transferNe(msg) {
      this.$emit('transferNe', msg);
    },
    /**
     * 重新加载网元和任务树
     */
    reloadTree() {
      this.$refs.realtimeTaskTree.getMeasureObjUnderTaskTree();
      this.$refs.realtimeNeTree.getNeInfoUnderTaskTree();
    }
  },
  mounted() { }
};
</script>

<style>
</style>
